import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { theme } from "@livecommerce/ui";
import "@mantine/core/styles.css";
import "@livecommerce/ui/theme.css";
// After the shared theme, so the panel's own page background wins over anything Mantine or
// `theme.css` sets on `body`. See the note in the file for why it is not in the shared theme.
import "./app.css";
import "./i18n";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from the document");
}

createRoot(container).render(
  <StrictMode>
    {/*
      Light, not `auto`, and the reason is the brand asset rather than taste. The logo is
      `assets/peeko-logo.svg`, drawn in near-black with no light-ink variant — on a dark surface it
      would be invisible, and the sign-in screen leads with it. The brand direction is white
      backgrounds besides.

      Revisit when there is a light-ink logo, or if operators driving a live show make the case for a
      dark panel. Both are real possibilities; neither is settled by this line.
    */}
    <MantineProvider theme={theme} defaultColorScheme="light">
      <App />
    </MantineProvider>
  </StrictMode>,
);
